import { Action, Dispatch } from "redux";
import { ResLayoutDto } from "../../dto/layout/Response/ResLayout";
import { MemberInfoResDto } from "../../dto/vending/MemberInfoResDto";
import { PromotionDto } from "../../dto/vending/PromotionDto";
import { VMProductInfoDto } from "../../dto/vending/VMProductInfoDto";
import { FGetState } from "../app.reducer";

/**
 * Functon type declare
 */
export type FuncAction = (
    dispatch: Dispatch,
    getState: FGetState
) => Promise<void>;

/**
 * Function sync type declare
 */
export type FuncSyncAction = (dispatch: Dispatch, getState: FGetState) => void;

/**
 * Store action type declare
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    PRODUCT: {
        MEMBER_INFO_SUCCESS: "PRODUCT_MEMBER_INFO_SUCCESS",
        MEMBER_INFO_FAIL: "PRODUCT_MEMBER_INFO_FAIL",
        START_LOADING: "START_LOADING",
        STOP_LOADING: "STOP_LOADING",
    },
    SEARCH: {
        RESULT: "SEARCH_RESULT",
        RESET: "SEARCH_RESET",
    },
    LAYOUT_TRG: {
        LOADING: "LAYOUT_TRG_LOADING",
        SUCCESS: "LAYOUT_TRG_SUCCESS",
        CLEAN: "LAYOUT_TRG_CLEAN",
        ERROR: "LAYOUT_TRG_ERROR",
    },
    PRODUCT_TRG: {
        LOADING: "PRODUCT_TRG_LOADING",
        SUCCESS: "PRODUCT_TRG_SUCCESS",
        CLEAN: "PRODUCT_TRG_CLEAN",
        ERROR: "PRODUCT_TRG_ERROR",
    },
    PRODUCT_GROUP_TRG: {
        LOADING: "PRODUCT_GROUP_TRG_LOADING",
        SUCCESS: "PRODUCT_GROUP_TRG_SUCCESS",
        CLEAN: "PRODUCT_GROUP_TRG_CLEAN",
        ERROR: "PRODUCT_GROUP_TRG_ERROR",
    },
    PRODUCT_CAFE_GROUP_TRG: {
        SUCCESS: "PRODUCT_CAFE_GROUP_TRG_SUCCESS",
        CLEAN: "PRODUCT_CAFE_GROUP_TRG_CLEAN",
    },
    PROMOTION_TRG: {
        LOADING: "PROMOTION_TRG_LOADING",
        SUCCESS: "PROMOTION_TRG_SUCCESS",
        CLEAN: "PROMOTION_TRG_CLEAN",
        ERROR: "PROMOTION_TRG_ERROR",
    },
};

/**
 * All store state
 */
export interface ProductState {
    isInit?: boolean;
    isLoading?: boolean;
    isSearching?: boolean;
    error?: any;
    productSearchResult?: Array<VMProductInfoDto>;
    memberInfo?: MemberInfoResDto,
    layout: ResLayoutDto,
    productList?: Array<VMProductInfoDto>;
    productGroupList?: Array<VMProductInfoDto>;
    productCafeGroupList?: Array<VMProductInfoDto>;
    promotionList?: Array<PromotionDto>
}

/**
 * Store's action definition
 */
export interface IProductAction extends Action {
    payload: any;
    error: any;
}
